import React from "react";

export function inflectNumber(i: number) {
  if(i % 10 === 1) return `${i}st`;
  if(i % 10 === 2) return `${i}nd`;
  if(i % 10 === 3) return `${i}rd`;
  return `${i}th`;
}

export const Empty: React.FC<{}> = () => <></>